import { Env } from '@Constants/BuildInfo';

// eslint-disable-next-line import/prefer-default-export
export const CDDOptions = {
  licenseUrl: `${Env.StructureEditorsHostUrl}/cdn/chemdrawweb/ChemDraw-JS-License.xml`,
  configUrls: {
    default: `${Env.StructureEditorsHostUrl}/cdn/chemdrawweb/configuration.json`,
    noclipboard: `${Env.StructureEditorsHostUrl}/cdn/chemdrawweb/configuration-noclipboard.json`,
  },
};
